export default __webpack_public_path__ + "static/media/ViewCollab.781e4e5d.jpg";